import { useState } from "react";

const navItems = [
  { href: "#synopsis", label: "作品简介" },
  { href: "#formats", label: "四种形式" },
  { href: "#library", label: "内容目录" },
  { href: "#characters", label: "人物小传" },
  { href: "#guide", label: "追更指南" },
  { href: "#faq", label: "常见问题" },
];

export default function NavBar() {
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 border-b border-background-200/70 bg-background-50/90 backdrop-blur">
      <div className="mx-auto flex h-16 w-full items-center justify-between gap-4 px-4 md:px-8">
        <a href="#top" className="flex items-center gap-2.5 whitespace-nowrap">
          <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
            <i className="ri-moon-foggy-line text-lg" />
          </span>
          <span className="flex flex-col leading-tight">
            <span className="font-heading text-base font-bold text-foreground-950">善良的嫂子</span>
            <span className="text-[11px] tracking-wide text-foreground-500">全集资源导航站</span>
          </span>
        </a>

        <nav className="hidden items-center gap-1 md:flex">
          {navItems.map((item) => (
            <a
              key={item.href}
              href={item.href}
              className="rounded-md px-3 py-2 text-sm text-foreground-700 transition-colors hover:bg-background-100 hover:text-primary-700"
            >
              {item.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <a
            href="#library"
            className="hidden whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 md:inline-flex"
          >
            进入内容目录
          </a>
          <button
            type="button"
            aria-label="展开导航菜单"
            aria-expanded={open}
            onClick={() => setOpen((prev) => !prev)}
            className="flex h-10 w-10 cursor-pointer items-center justify-center rounded-md border border-background-200 text-foreground-800 md:hidden"
          >
            <i className={open ? "ri-close-line text-xl" : "ri-menu-2-line text-xl"} />
          </button>
        </div>
      </div>

      {open ? (
        <div className="border-t border-background-200/70 bg-background-50 md:hidden">
          <nav className="mx-auto flex w-full flex-col px-4 py-3">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={() => setOpen(false)}
                className="rounded-md px-3 py-3 text-sm text-foreground-700 transition-colors hover:bg-background-100 hover:text-primary-700"
              >
                {item.label}
              </a>
            ))}
          </nav>
        </div>
      ) : null}
    </header>
  );
}